import { render, staticRenderFns } from "./ProjectGroupList.vue?vue&type=template&id=a81960a8&lang=pug&"
import script from "./ProjectGroupList.vue?vue&type=script&lang=js&"
export * from "./ProjectGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectGroupList.vue"
export default component.exports